module.exports = __webpack_public_path__ + "img/f12.394f51ad.jpg";